<template lang="pug">
v-app#app
  router-view
</template>
<script>
import { mapActions } from "vuex";
import { auth } from "@/firebase";

export default {
  name: "app",
  mounted() {
    this.onAuth();

    setInterval(() => {
      auth.currentUser.getIdToken(true);
    }, 60 * 30 * 1000);
  },
  methods: {
    ...mapActions("auth", ["onAuth"])
  }
};
</script>
<style lang="stylus"></style>
